import { Flex, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

interface CustomFieldBadgeProps {
  customField?: string; // The label or title of the field
  fieldValue: string; // The value of the field
  bgColor?: string; // Background color for the label container
  titleColor?: string; // Color for the field title
  valueColor?: string; // Color for the field value
  showCustomFieldLabel?: boolean;
  url?: string;
}

const CustomFieldBadge: React.FC<CustomFieldBadgeProps> = ({
  customField,
  fieldValue,
  bgColor = 'gray.50', // Default background color
  titleColor = 'text.primary', // Default title color
  valueColor = 'text.primary', // Default value color
  showCustomFieldLabel = true,
  url
}) => {
  const navigate= useNavigate()
  return (
    <Flex
      onClick={() => {
        if (url) {
          navigate(url);
        }
      }}
      cursor={url ? 'pointer' : 'text'}
      padding="0.25rem 0.5rem"
      alignItems="center"
      gap="0.25rem"
      borderRadius="0.25rem"
      bg={bgColor}
      flexDirection="row"
      wrap="wrap"
      flexShrink={0}
      maxWidth="100%"
    >
      {showCustomFieldLabel && (
        <Text
          fontSize="0.75rem"
          fontWeight="400"
          lineHeight="1rem"
          color={titleColor}
          whiteSpace={'nowrap'}
        >
          {customField}
        </Text>
      )}
      <Text
        fontSize="0.75rem"
        fontWeight="700"
        lineHeight="1rem"
        color={valueColor}
        wordBreak="break-word"
        whiteSpace="normal"
        flex="1"
        minWidth="0"
      >
        {fieldValue}
      </Text>
    </Flex>
  );
};

export default CustomFieldBadge;
